function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEmployeesSideNav = function SvgEmployeesSideNav(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 52,
    height: 40,
    fill: "none",
    viewBox: "0 0 52 40"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: props.fill,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M31 29v-2a4 4 0 0 0-4-4h-8a4 4 0 0 0-4 4v2M23 19a4 4 0 1 0 0-8 4 4 0 0 0 0 8ZM37 29v-2a4 4 0 0 0-3-3.87M30 11.13a4 4 0 0 1 0 7.75"
  }));
};
export default SvgEmployeesSideNav;